var menuDropdownItems = document.querySelectorAll('header-menu details');
menuDropdownItems.forEach((menuDropdownItem) => {
  menuDropdownItem.addEventListener('mouseover', function() {
    menuDropdownItem.setAttribute('open', true);
  });
  menuDropdownItem.addEventListener('mouseout', function() {
    menuDropdownItem.removeAttribute('open', true);
  });
});

window.addEventListener('scroll', function() {
    var h_height = $('.shopify-section-header-sticky').height();
    if (window.innerWidth <= 768) {
        if (window.scrollY < 525) {
            document.querySelector('.countdown-hp').classList.remove('countdown-fixed');
        } else {
            document.querySelector('.countdown-hp').classList.add('countdown-fixed');
            $('.m-count-down').css('top',h_height);
        }
    } else {
        if (window.scrollY < 650) {
            document.querySelector('.countdown-hp').classList.remove('countdown-fixed');
        } else {
            document.querySelector('.countdown-hp').classList.add('countdown-fixed');
            $('.m-count-down').css('top',h_height);
        }
    }
});

  $(document).on('change','.bundle-product-select',function(){
      var image = $(this).find('option:selected').data('image');
      $(this).parents('.bundle-product-item').find('.bundle-product-image').attr('src',image);
  });

  $(document).on('click','.custom-bundle-addtocart-button',function(){
    jsonObj = [];
    $(this).parents('.bundle-block-content').find('.bundle-product-item').each(function(){
      var current_variant = $(this).find('.bundle-product-select').val();
      var get_line_item = $(this).find('.for-line-item').text();
      item = {}
      item ["id"] = parseInt(current_variant);
      item ["quantity"] = 1;
      if(get_line_item){
        item ["properties"] = {'Entries':get_line_item};
      }
      jsonObj.push(item);
    });
      $.ajax({
      type: "POST", 
      url: '/cart/add.js',
      data: {items: jsonObj },
      dataType: "json",
      success: function() {
        window.upcartOpenCart();
        window.upcartRegisterAddToCart();
      }
    }); 
  });
